
import { Component, Vue } from "vue-property-decorator";

@Component
export default class PublicNotFound extends Vue {
  private backToLogin() {
    this.$router.push("/login");
  }
}
